export const fixedColorMaps = {
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Title2-Land.json': {
        '11422071': 11421814,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Title4-Square.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Quote1-Square-v2.json': {
        '2705634': 2639842,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-TextDefault-Land.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Quote2-Square-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Head1-Square-v1.json': {
        '2705634': 2639842,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Head2-Square-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text1-Square-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text2-Square-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text3-Square-v1.json': {
        '2705634': 2639842,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text5-Square-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text4-Square-v1.json': {
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text6-Square-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text7-Square-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Stat1-Square-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Outro5-Square-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Title1-Square.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_stat1_square.json': {
        '18291': 18035,
        '14309732': 14243939,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text9_square.json': {
        '2514320': 2448527,
        '14309732': 14243939,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_textdefault_square.json': {
        '15753581': 15688044,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_TextQuote3_square1.json': {
        '20095': 19838,
        '9353526': 9287733,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_OutroScene1_square2.json': {
        '20095': 19838,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_OutroScene5_square1.json': {
        '20095': 19838,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_textdefault_landscape.json': {
        '16746901': 16746900,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title1_square_withoutgraph.json': {
        '20095': 19838,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title2_square.json': {
        '349060': 283268,
        '11919453': 11919197,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text1_square.json': {
        '20095': 20094,
        '15819374': 15753581,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title3_square_new2.json': {
        '20095': 19838,
        '8497200': 8431664,
        '16744054': 16744053,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text2_square.json': {
        '11919453': 11919197,
        '14309732': 14243939,
        '16645629': 16579836,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title4_square.json': {
        '20095': 19838,
        '16776191': 16775935,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_list1_square.json': {
        '9353527': 9287734,
        '15819374': 15753581,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text3_square.json': {
        '18291': 18035,
        '83827': 18035,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_list2_square.json': {
        '18291': 18035,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text4_square.json': {
        '18291': 18035,
        '8497200': 8431664,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text5_square.json': {
        '14309732': 14243939,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_TextQuote2_land2.json': {
        '9353526': 9287733,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_TextScene6_square.json': {
        '20095': 19839,
        '9353526': 9287734,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text7_landscape.json': {
        '20095': 19838,
        '16776191': 16775935,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text11_square.json': {
        '18291': 18035,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_listicleHeading1_square_2.json': {
        '20095': 19838,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text8_landscape.json': {
        '20095': 19838,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_scene12_square2.json': {
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_listicleHeading2_square_1.json': {
        '20095': 19838,
        '9353526': 9287733,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_listicleHeading3_square_1.json': {
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/CBRE-Bulletpoints-Square.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-ChapterMarker1-Square-Lottie.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-LowerThirds-Square-Lottie-v2.json': {
        '141869': 141868,
        '1566863': 1501326,
        '16316664': 16250872,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-TextCallout-Square-Lottie.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-Intro1-Square-Lottie.json': {
        '141869': 141868,
        '1566863': 1501326,
        '16316664': 16250872,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Title3-Land.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Title4-Vert-v2.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Quote1-Vert-v1.json': {
        '2705634': 2639842,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Quote2-Vert-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Head1-Vert-v1.json': {
        '2705634': 2639842,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Head2-Vert-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text1-Vert-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text2-Vert-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text3-Vert-v1.json': {
        '2705634': 2639842,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text5-Vert-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text4-Vert-v1.json': {
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-TextDefault-Vert-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text6-Vert-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text7-Vert-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text8-Vert.json': {
        '2705634': 2639842,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text9-Vert.json': {
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Stat1-Vert-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Outro5-Vert-v2.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Title1-Vertical-v2.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_stat1_vertical.json': {
        '18291': 18035,
        '14309732': 14243939,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text9_vertical.json': {
        '2514320': 2448527,
        '14309732': 14243939,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_textdefault_vertical_new.json': {
        '16746901': 16746900,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_TextQuote3_vert1.json': {
        '20095': 19838,
        '9353526': 9287733,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_OutroScene1_vert2.json': {
        '20095': 19838,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_OutroScene5_vert2.json': {
        '20095': 19838,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title1_vertical.json': {
        '20095': 19838,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title2_vertical_new.json': {
        '349060': 283268,
        '11919453': 11919197,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text1_vertical.json': {
        '477556': 412019,
        '15822465': 15822464,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title3_vertical2.json': {
        '20095': 19838,
        '8497200': 8431664,
        '16744054': 16744053,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text2_vertical_new.json': {
        '11919453': 11919197,
        '14309732': 14243939,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_list1_vertical.json': {
        '9353527': 9287734,
        '15819374': 15753581,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text3_vertical.json': {
        '18291': 18035,
        '83827': 18035,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_list2_vertical.json': {
        '18291': 18035,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text4_vertical.json': {
        '18291': 18035,
        '8497200': 8431664,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text5_vertical.json': {
        '14309732': 14243939,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_TextScene6_vertical_1.json': {
        '20095': 19839,
        '9353526': 9287734,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text11_vertical.json': {
        '18291': 18035,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_listicleHeading1_verticle_1.json': {
        '20095': 19838,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_scene12_vert_1.json': {
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_listicleHeading2_vert_1.json': {
        '20095': 19838,
        '9353526': 9287733,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_listicleHeading3_vert_1.json': {
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/GFK/GFK-OutroA-Vert-1.json': {
        '1566863': 1501326,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-TextOverImage-Vert-Lottie.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/CBRE-Bulletpoints-Vert.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-ChapterMarker1-Vert-Lottie.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-LowerThirds-Vert-Lottie-v2.json': {
        '141869': 141868,
        '1566863': 1501326,
        '16316664': 16250872,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-TextCallout-Vert-Lottie.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-Intro1-Vert-Lottie.json': {
        '141869': 141868,
        '1566863': 1501326,
        '16316664': 16250872,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Title4-Land.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Quote1-Land-v1.json': {
        '2705634': 2639842,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Quote2-Land-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Head1-Land-v1.json': {
        '2705634': 2639842,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Head2-Land-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text1-Land-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text2-Land-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text3-Land-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text5-Land-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text4-Land-v1.json': {
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text6-Land-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text7-Land-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text8-Land.json': {
        '2705634': 2639842,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Text9-Land-v2.json': {
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Stat1-Land-v1.json': {
        '2705634': 2639842,
        '11422071': 11356535,
        '15645717': 15580180,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/Saturate-Title1-Land.json': {
        '2705634': 2639842,
        '11422071': 11356535,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_stat1_landscape.json': {
        '18291': 18034,
        '15819374': 15753581,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text9_landscape_new.json': {
        '2383248': 2317455,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_TextQuote3_land2.json': {
        '9353526': 9287733,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_OutroScene1_land2.json': {
        '20095': 19838,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_OutroScene5_1.json': {
        '20095': 19838,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_TitleScene1_Land_2.json': {
        '20095': 19838,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title2_landscape.json': {
        '349060': 283268,
        '11919453': 11919197,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text1_landscape_new3.json': {
        '20095': 20094,
        '14540121': 14540120,
        '15819374': 15753581,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title3_landscape_new3.json': {
        '20095': 19838,
        '8497200': 8431664,
        '16744054': 16744053,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text2_landscape_withlines_new.json': {
        '9353526': 9353270,
        '11919453': 11853660,
        '14309732': 14243939,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title4_landscape_new.json': {
        '349060': 283268,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_list1_landscape.json': {
        '9353527': 9287734,
        '15819374': 15753581,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_list2_landscape.json': {
        '18291': 18035,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text4_landscape_new.json': {
        '18291': 18035,
        '9353526': 9353270,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_title3_landscape_new2.json': {
        '20095': 19838,
        '8497200': 8431664,
        '16744054': 16744053,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text5_landscape.json': {
        '14309732': 14243939,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_TextScene6_land2.json': {
        '20095': 19839,
        '9353526': 9287734,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text7_landscape_new.json': {
        '349060': 283268,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/geek_text11_landscape.json': {
        '18291': 18035,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_listicleHeading1_land_3.json': {
        '20095': 19838,
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_scene12_land_1.json': {
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_listicleHeading2_land_1.json': {
        '20095': 19838,
        '9353526': 9287733,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Geek/Geek_text_listicleHeading3_land_1.json': {
        '15819374': 15819118,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/GFK/GFK-OutroA-Land-1.json': {
        '1566863': 1501326,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/GFK/GFK-OutroC-Land-1.json': {
        '8421504': 8355711,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-TextOverImage-Land-Lottie.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/Saturate/CBRE-Bulletpoints-Land.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-ChapterMarker1-Land-Lottie.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-LowerThirds-Land-Lottie-v2.json': {
        '141869': 141868,
        '1566863': 1501326,
        '16316664': 16250872,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-TextCallout-Land-Lottie.json': {
        '141869': 141868,
    },
    'https://storage.googleapis.com/lumen5-prod-lottie/CBRE/CBRE-Intro1-Land-Lottie.json': {
        '141869': 141868,
        '1566863': 1501326,
        '16316664': 16250872,
    },
};
